import React from 'react';
import { colorScheme, colorSchemeBar } from "./constants";

// function to format mumber in k, M, B, T
export const formatNumber = (num, digits) => {
  if (num === 'TO' || num === 0) {
    return num
  }
  if (num) {
    var si = [
      { value: 1, symbol: "" },
      { value: 1E3, symbol: "K" },
      { value: 1E6, symbol: "M" },
      { value: 1E9, symbol: "B" },
      { value: 1E12, symbol: "T" },
      { value: 1E15, symbol: "P" },
      { value: 1E18, symbol: "E" }
    ];
    var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var i;
    num = num.toString().replace(/,/g, '');
    for (i = si.length - 1; i > 0; i--) {
      if (num >= si[i].value) {
        break;
      }
    }
    digits = digits ? digits : 2;
    const r = (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol
    return r === "NaN" ? '...' : r;
  }
  return;
}

/**
 * 
 * @param {string} activeAlertId alertId for the the data has to be relterived
 * @param {array} alertList 
 * @param {array} cachedAlerts alerts fetched from api
 * @returns returns data formatted to draw pie chart
 */
export const getPieChartData = (activeAlertId, alertList, cachedAlerts, profileId, liveChart) => {
  const activeAlertKey = profileId ? profileId + '-' + activeAlertId : activeAlertId;
  const activeAlert = _.keyBy(alertList, 'alert_id')[activeAlertId];
  const res = {
    "title": activeAlert ? activeAlert.name : '',
    "chartData": {
      data: [],
      total: 0
    },
    "alertId": activeAlertKey
  }
  let activeValEl = {};
  const cachedAlertKeys = Object.keys(cachedAlerts);
  if (cachedAlertKeys.length > 0) {
    cachedAlertKeys.map((o, i) => {
      if (o === activeAlertKey) {
        activeValEl = Object.values(cachedAlerts)[i];
      }
      return o;
    });

    let { data, props } = activeValEl;
    // if it's a live chart, then existing props don't have the updated bucket details
    if (liveChart) {
        data = liveChart.data;
        props = liveChart.props;
    }
    data && data.map((obj, i) => {
      if (i > 0 && i <= props.buckets.length) {
        const label = props.bucketLabels[i - 1];
        label && res.chartData.data.push({
          "id": label,
          "label": label,
          "value": obj ? obj : 0,
          "color": colorScheme[(props.buckets[i]).toLowerCase()]
        })
      }
      if(i===0){
        res.chartData.total = obj ? obj : 0
      }
      return obj;
    })
  }


  return res;
}


export const getBarChartData = (activeAlertId, alertList, cachedAlerts, profileId, liveChart) => {
  
  let activeAlertKey = '';
  let activeAlert = '';
  let combinedAlerts = [];
  let liveTitle = '';

  if (activeAlertId !== "") {
    activeAlertKey = profileId ? profileId + '-' + activeAlertId : activeAlertId;
    activeAlert = _.keyBy(alertList, 'alert_id')[activeAlertId];
    combinedAlerts = cachedAlerts[activeAlertKey].props.combinedAlerts;
  }

  if (liveChart?.combinedAlerts?.length > 0) {
    combinedAlerts = liveChart.combinedAlerts;
    liveTitle = liveChart.liveTitle ? liveChart.liveTitle: '';
  }

  const res = {
    "title": activeAlert ? activeAlert.name : liveTitle,
    "chartData": {
      data: []
    },
    "alertId": activeAlertKey,
    "bucketLabels": getBucketLabels(combinedAlerts)
  }
  const colorLen = Object.values(colorSchemeBar).length;
  let defaultIndex = 0;
  res.bucketLabels.map( (bucket, i) => {
    if(i>0 && bucket && defaultIndex===0){
      defaultIndex = i
    } 
    return bucket;
  })
  res.chartData.data = combinedAlerts.map((obj, i) => {
    const datum = {
      id: obj.props ? obj.props.name : '',
      value: obj.data ? obj.data[defaultIndex + 1] : 0,
      values: obj.data ? obj.data : [],
      color: Object.values(colorSchemeBar)[i%colorLen],
      alert_profile_id: obj.props ? obj.props.alert_profile_id : ''
    }
    return datum;
  })
  return res;
}

/**
 * returns array of most non-empty bucket label
 */
export const getBucketLabels = (combinedAlerts) => {
  let nonEmptyCount = 0;
  let resultBLbls = []
  combinedAlerts.map(alert => {
    const nonEmptyBucketLabels = alert.props?.bucketLabels ? alert.props.bucketLabels.filter( v => (v !== null && v !== "") ) : [];
    if(nonEmptyBucketLabels.length > nonEmptyCount){
      nonEmptyCount = nonEmptyBucketLabels.length;
      resultBLbls = alert.props.bucketLabels;
    }
  })
  return resultBLbls;
}

export const switchChartData = (dataIdx, data) => {
  const newChartData = data.chartData.data.map( (d, i) => {
    d.value = d.values[dataIdx];
    return d;
  })
  data.chartData.data = newChartData;
  return data;
}

export const drillDownResizehandler  = (MainGrid) => {
  const MIN_DD_HEIGHT = 200;
  var topPanelHeight = $('.topPanel') ? ($('.topPanel').height() + 16) : 0;
  var drilldown_height = $(window).height() - 80 - topPanelHeight;
  drilldown_height = Math.max(MIN_DD_HEIGHT, drilldown_height);
  $("#drilldownPanel").css({ height: ( drilldown_height) + 'px' });

  var drilldown_width = $("#drilldownPanel").width();
  if (navigator.userAgent.match(/Trident/)) {
      drilldown_width = drilldown_width - 11;
  }
  $("#drilldowndata").css( { 
      height: (drilldown_height - 23) + 'px',
      width:  (drilldown_width  -  0) + 'px' 
  });
  $("#drilldowndata .slick-viewport").css( { 
      height: (drilldown_height - 60) + 'px'
  });
  
  if (MainGrid) {
      MainGrid.resizeCanvas();
      MainGrid.onViewportChanged.notify ();
  }

}

export const formatChartName = (name)=>{
 return name ? (name + '').replace(/\[.*\]/, '') : ''
}

/**
 * 
 * @param {string} colorCode 
 * @returns colorName from hex colorCode
 */
export const getColorName = (colorCode) => {
  let colorName = '';
  Object.values(colorScheme).map( (curColor, i) => {
    if(colorCode === curColor){
      colorName = Object.keys(colorScheme)[i];
      return colorName;
    }
  })
  return colorName;
}

export const getDashboardNameById = (dashboardId, alertDashboards) => {
  let dashboardName = '';
  alertDashboards.forEach((item) => {
    if(item.dashboard_id == dashboardId) { 
      dashboardName = item.dashboard_name; 
    }
    return item;
  })
  return dashboardName
}

export const formatNumberSeparators = (num) => {
  let number = '';

  if((num % 1) === 0) {
    var numArr = num.toString().split(".");
    numArr[0] = numArr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    number = numArr.join(".");
  } else {
    number = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  return number;
}

export const getHPFonts = () => {
  const path = window.location.href.split("bmt.html")[0] + 'fonts/';
  const fontNames = ['HPSimplifiedW01-light.woff', 'HPSimplifiedW01-lightItalic.woff', 'HPSimplifiedW01-Regular.woff', 'HPSimplifiedW01-bold.woff'];
  const font = {
    urls: [],
    css: ''
  };
  fontNames.forEach((fName, i) => {
    let fontUrl = path + fName;
    let fontWeight = 100;
    let fontstyle = 'normal';
    if (i == 1) { fontstyle = 'italic' }
    if (i == 2) { fontWeight = 400 }
    if (i == 3) { fontWeight = 700 }
    const cssStyle = `@font-face {
      font-family: HPSimplified;
      src: url(${fontUrl}) format('woff');
      font-weight: ${fontWeight};
      font-style: ${fontstyle}
    }`;
    font.css = font.css + cssStyle;
    font.urls.push(fontUrl)
  })
  return font;
}
